import { Injectable } from '@angular/core';
import { isObservable, lastValueFrom, Observable, timer } from 'rxjs';


export function nameof<T>(key: keyof T, instance?: T): keyof T {
    return key;
}

@Injectable({
    providedIn: 'root'
})
export class UtilitiesRxjs {

    static async await(miliseconds: number, callBack?: () => void): Promise<number> {
        const result = lastValueFrom(timer(miliseconds));
        if (callBack) {
            result.then(callBack);
        }

        return result;
    }

    static readonly isPromise = obj => !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';

    static async handleData<T>(data: T | Promise<T> | Observable<T>): Promise<T> {
        if (isObservable(data)) {
            return lastValueFrom(data);
        } else if (data instanceof Promise) {
            return data;
        } else {
            return Promise.resolve(data);
        }
    }
}
